<template>
    <div class="view-applicants">
    <div class="applicants-page">
      <div class="applicants-header">
        <div class="applicants-context">
          <span class="applicants-context-label">Applicants For:</span>
          <span class="applicants-context-value">{{ selected_applicant_profile_name }}</span>
        </div>

        <div class="applicants-header-actions">
          <div class="dropdown">
            <button
              class="applicants-export-btn dropdown-toggle"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              :disabled="is_downloading_documents_zip || !pending_applications_list.length"
            >
              <i
                class="bi"
                :class="is_downloading_documents_zip ? 'bi-arrow-repeat applicants-export-btn-spinner' : 'bi-file-earmark-zip'"
              ></i>
              {{ is_downloading_documents_zip ? "Preparing documents..." : "Documents" }}
            </button>
            <ul class="dropdown-menu dropdown-menu-end shadow-sm">
              <li>
                <button
                  type="button"
                  class="dropdown-item text-xxs"
                  @click="download_all_documents_zip(false)"
                >
                  Applicant folders ZIP
                </button>
              </li>
              <li>
                <button
                  type="button"
                  class="dropdown-item text-xxs"
                  @click="download_all_documents_zip(true)"
                >
                  Merged PDF
                </button>
              </li>
            </ul>
          </div>
          <button
            class="applicants-export-btn"
            :disabled="is_downloading_selection_grid_excel || !pending_applications_list.length"
            @click="download_selection_grid_excel"
          >
            <i class="bi bi-download"></i>
            Excel
          </button>
        </div>
      </div>

      <div class="applicants-summary-grid">
        <button
          type="button"
          class="applicants-summary-card"
          :class="{ 'applicants-summary-card-active': active_compliance_card === 'all' }"
          @click="set_compliance_card_filter('all')"
        >
          <small>Total Applicants</small>
          <strong>{{ totalApplicants }}</strong>
          <span>All</span>
        </button>
      </div>

      <div v-if="displayed_applications_list.length" class="applicants-table-shell">
        <div class="applicants-table-hint">
          <i class="bi bi-eye-slash applicants-table-hint-icon" aria-hidden="true"></i>
          <span>Click any column header to hide it</span>
        </div>
        <GlobalTable
          :key="table_render_key"
          :headers="table_headers"
          :data="displayed_applications_list"
          table_id="applicants-selection-grid"
          :responsive="false"
          :enable_column_toggle="true"
        >
          <template #actions="{ row }">
            <div class="d-flex gap-1">
              <button
                type="button"
                class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
                @click="redirect_to_application_overview(row)"
              >
                View
              </button>
            </div>
          </template>
        </GlobalTable>
      </div>

      <div v-else class="applicants-empty-state">
        <i class="fa-solid fa-inbox"></i>
        <p>No applications found</p>
      </div>
    </div>

    <div
      v-if="is_downloading_documents_zip"
      class="applicants-export-overlay"
      role="status"
      aria-live="polite"
    >
      <div class="applicants-export-progress-card">
        <div class="applicants-export-progress-icon" aria-hidden="true">
          <i class="bi bi-arrow-repeat applicants-export-btn-spinner"></i>
        </div>
        <p>{{ document_export_label }}</p>
        <strong>{{ document_export_progress }}%</strong>
        <div
          class="applicants-export-progress-track"
          role="progressbar"
          :aria-valuenow="document_export_progress"
          aria-valuemin="0"
          aria-valuemax="100"
          :aria-label="document_export_label"
        >
          <span :style="{ width: `${document_export_progress}%` }"></span>
        </div>
        <small>{{ document_export_detail }}</small>
      </div>
    </div>

    <button id="open_assign_modal_btn" type="button" class="d-none" data-bs-toggle="modal"
      data-bs-target="#assign_sub_entity_modal">
    </button>

    <teleport to="body">
      <div v-if="show_log_modal" class="modal fade show d-block" tabindex="-1">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header bg-green-dark d-flex justify-content-center">
              <h6 class="modal-title text-center w-100 text-white">Application Timeline</h6>
              <button type="button" class="btn-close position-absolute end-0 me-3" aria-label="Close"
                @click="show_log_modal = false">
              </button>
            </div>
            <div class="timeline-modal-body">
              <ApplicationLog :status="selected_log_status" :user_id="user_id" />
            </div>
          </div>
        </div>
      </div>
    </teleport>

    <div v-if="show_log_modal" class="modal fade show" @click="show_log_modal = false"></div>
  </div>
</template>
